export default __webpack_public_path__ + "static/RightTree-785ed3e0050cfd67d719b4f9a30e007d.svg";